import { render, staticRenderFns } from "./ArrowReturn.vue?vue&type=template&id=64817868&"
import script from "./ArrowReturn.vue?vue&type=script&lang=ts&"
export * from "./ArrowReturn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports